module.exports = __webpack_public_path__ + "img/logo.d29869e2.webp";